import { splitTopLevelArgs, findEntityById } from './stepText'

// ---------------------------------------------------------------------------
// Leitura do IfcGeometricRepresentationContext.TrueNorth.
//
// TrueNorth é a direção do norte GEOGRÁFICO expressa no referencial do
// projeto (uma IfcDirection 2D no plano XY). É MERAMENTE DECLARATIVA por
// spec: não roda a geometria, apenas informa quanto é que o eixo +Y do
// projeto se afasta do norte verdadeiro. Por isso só a expomos como
// informação no Info do modelo, sem tocar no placement.
//
// Ângulo devolvido: do +Y do projeto para o norte verdadeiro, no sentido
// horário (bearing), em graus. atan2(x, y): (0,1) -> 0°, (1,0) -> 90°.
// null quando o contexto não declara TrueNorth (arg em falta ou $).
// ---------------------------------------------------------------------------

/** Extrai o ângulo TrueNorth declarado (graus) do texto STEP, ou null. */
export function detectTrueNorthDeg(text: string): number | null {
  const re =
    /#(\d+)\s*=\s*IFCGEOMETRICREPRESENTATIONCONTEXT\s*\(([^)]*)\)/g
  for (let m = re.exec(text); m; m = re.exec(text)) {
    const args = splitTopLevelArgs(m[2])
    // Ordem: ContextIdentifier, ContextType, CoordinateSpaceDimension,
    // Precision, WorldCoordinateSystem, TrueNorth. TrueNorth = índice 5.
    const tn = args[5]?.trim()
    if (!tn || tn === '$') continue
    const idm = tn.match(/^#(\d+)$/)
    if (!idm) continue
    const dir = findEntityById(text, Number(idm[1]))
    if (!dir || dir.type !== 'IFCDIRECTION') continue
    // IfcDirection(DirectionRatios): dir.args é o texto cru "(x,y[,z])".
    const nums = dir.args
      .trim()
      .replace(/^\(|\)$/g, '')
      .split(',')
      .map((s) => Number(s.trim()))
    if (nums.length < 2 || !Number.isFinite(nums[0]) || !Number.isFinite(nums[1])) {
      continue
    }
    const [x, y] = nums
    if (x === 0 && y === 0) continue
    return (Math.atan2(x, y) * 180) / Math.PI
  }
  return null
}
